// Auth0Strategy.js
import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { auth0Config } from '../../config';

const Auth0StrategyProvider = ({ children }) => {
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        audience: auth0Config.audience,
        redirect_uri: `${window.location.origin}/login`,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0StrategyProvider;
